// サービス終了に伴いAPIを停止したため、更新系の操作は利用できない
import { rejectServiceClosed } from 'api/errors';

interface DeleteUserRequest {
  email: string;
  password: string;
}

export const useDeleteUser = () => {
  const deleteUser = (_data: DeleteUserRequest): Promise<void> => rejectServiceClosed();

  return { deleteUser };
};
